// extracted by css-extract-rspack-plugin
export default {"Box":"row-reorder-sash-module__Box__1Hmzz","Octicon":"row-reorder-sash-module__Octicon__qdxdy"};